import a from "./_isArray.mjs";
function u(e, n) {
  return function() {
    var t = arguments.length;
    if (t === 0)
      return n();
    var r = arguments[t - 1];
    return a(r) || typeof r[e] != "function" ? n.apply(this, arguments) : r[e].apply(r, Array.prototype.slice.call(arguments, 0, t - 1));
  };
}
export {
  u as default
};
